/* eslint-disable @typescript-eslint/no-explicit-any */
import type React from 'react'

export const getTabsMeta = (
  tabsNode: HTMLDivElement | null,
  scrollLeftNormalized = 0
):
  | {
      clientWidth: number
      scrollLeft: number
      scrollTop: number
      scrollLeftNormalized: number
      scrollWidth: number
      top: number
      bottom: number
      left: number
      right: number
    }
  | undefined => {
  if (tabsNode) {
    const rect = tabsNode.getBoundingClientRect()
    // create a new object with ClientRect class props + scrollLeft
    return {
      clientWidth: tabsNode.clientWidth,
      scrollLeft: tabsNode.scrollLeft,
      scrollTop: tabsNode.scrollTop,
      scrollLeftNormalized,
      scrollWidth: tabsNode.scrollWidth,
      top: rect.top,
      bottom: rect.bottom,
      left: rect.left,
      right: rect.right
    }
  }
  return
}

const getChildrenElementIndex = (
  children: HTMLCollection,
  valueToIndex: Map<any, any>,
  value: React.ReactText,
  moreIncludesList?: React.ReactText[]
): number =>
  moreIncludesList?.includes(value)
    ? children.length - 1
    : valueToIndex.get(value)

const findChildElement = (
  tabListNode: HTMLDivElement | null,
  value: React.ReactText,
  valueToIndex: Map<any, any>,
  moreIncludesList?: React.ReactText[],
  hideIndicator?: boolean
) => {
  const children = tabListNode?.children
  if (children) {
    const tab =
      children[
        getChildrenElementIndex(children, valueToIndex, value, moreIncludesList)
      ]
    if (!hideIndicator && process.env.NODE_ENV !== 'production') {
      if (!tab) {
        console.error(
          [
            `Tui: The value provided to the Tabs component is invalid.`,
            `None of the Tabs' children match with \`${value}\`.`,
            valueToIndex.keys
              ? `You can provide one of the following values: ${Array.from(
                  valueToIndex.keys()
                ).join(', ')}.`
              : null
          ].join('\n')
        )
      }
    }
    return tab
  }
  return
}

export const getTabMeta = (
  orientation: 'horizontal' | 'vertical',
  tabListNode: HTMLDivElement | null,
  valueToIndex: Map<any, any>,
  value?: React.ReactText,
  moreIncludesList?: React.ReactText[],
  hideIndicator?: boolean
): DOMRect | undefined => {
  if (tabListNode && value !== undefined && value !== null) {
    const children = tabListNode.children || []

    if (children.length > 0) {
      const tab = findChildElement(
        tabListNode,
        value,
        valueToIndex,
        moreIncludesList,
        hideIndicator
      )
      if (tab) {
        return orientation === 'vertical'
          ? tab.firstElementChild?.getBoundingClientRect()
          : tab.getBoundingClientRect()
      }
    }
  }
  return
}
